import { Container } from '@/components/layout/Container';
import { PRIMARY_NAV_HEIGHT } from '@/components/navigation/PrimaryNavigation';
import { IntegrationPartnerPageQuery } from '@/graphql';
import IntegrationPartnerPageQueryDocument from '@/graphql/queries/IntegrationPartnerPage.gql';
import { getStaticPageProps } from '@/lib/next';
import GlowQuoteModule from '@/modules/GlowQuote';
import IntegrationsCloudModule from '@/modules/IntegrationsCloud';
import SimpleCTAFooterModule from '@/modules/SimpleCTAFooter';
import SimpleHeroModule from '@/modules/SimpleHero';
import TextIllustrationColumnsModule from '@/modules/TextIllustrationColumns';
import TextListTableModule from '@/modules/TextListTable';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import MasterTemplate from '@/templates/MasterTemplate';
import styled from 'styled-components';

const PageWrapper = styled.section`
  padding-top: ${remCalc(PRIMARY_NAV_HEIGHT)};
  overflow: hidden;

  > * + * {
    margin-top: 60px;
  }

  ${mediaBreakpointUp('desktop')} {
    > * + * {
      margin-top: 120px;
    }
  }
`;

const GlowQuote = styled(GlowQuoteModule)`
  --orb-left-color: ${COLORS.RED.BASE};
  --orb-right-color: ${COLORS.GREEN.BASE};
`;

const IntegrationPartnerPage: PageTemplate<IntegrationPartnerPageQuery> = ({ entry }) => {
  return (
    <PageWrapper>
      <SimpleHeroModule props={entry?.moduleSimplehero} />
      <TextListTableModule props={entry?.moduleTextListTable} />
      <GlowQuote props={entry?.moduleGlowquote} />
      <Container>
        <IntegrationsCloudModule props={entry?.moduleIntegrationscloud} />
      </Container>
      <Container>
        <TextIllustrationColumnsModule props={entry?.moduleTextillustrationcolumns} />
      </Container>
      <SimpleCTAFooterModule props={entry?.moduleSimplectafooter} />
    </PageWrapper>
  );
};

IntegrationPartnerPage.template = MasterTemplate;

export default IntegrationPartnerPage;

export const getStaticProps = getStaticPageProps('partners/integration', async ({ client }) => {
  const { entry } = await client.request<IntegrationPartnerPageQuery>(IntegrationPartnerPageQueryDocument);

  return {
    props: {
      entry,
    },
  };
});
